import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { FormHelperText, Typography } from '@material-ui/core'

const FormImageField = ({
  input,
  meta: { touched, error },
  label,
  currentImage,
  previewAlt
}) => {
  const readerRef = useRef(null)

  const handleChange = event => {
    const file = event.target.files[0]

    if (!file) return
    if (readerRef.current) {
      readerRef.current.abort()
    }

    const reader = new FileReader()
    readerRef.current = reader

    reader.onload = () => {
      if (readerRef.current !== reader) return
      input.onChange(reader.result)
      input.onBlur()
    }

    reader.onerror = () => {
      if (readerRef.current !== reader) return
      input.onChange(null)
      input.onBlur()
    }

    reader.readAsDataURL(file)
  }

  React.useEffect(() => {
    return () => {
      if (readerRef.current &&
          readerRef.current.readyState === FileReader.LOADING) {
        readerRef.current.abort()
      }
    }
  }, [])

  const preview = typeof input.value === 'string' &&
    input.value.startsWith('data:image/')
    ? input.value
    : currentImage

  return (
    <div style={{ marginTop: 16 }}>
      <Typography component='label' htmlFor={input.name}>
        {label}
      </Typography>

      <input
        id={input.name}
        name={input.name}
        type='file'
        accept='image/*'
        onChange={handleChange}
      />

      {touched && error && (
        <FormHelperText error>{error}</FormHelperText>
      )}

      {preview && (
        <div>
          <img
            src={preview}
            alt={previewAlt}
            style={{ maxWidth: '100%', maxHeight: 240 }}
          />
        </div>
      )}
    </div>
  )
}

FormImageField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  currentImage: PropTypes.string,
  previewAlt: PropTypes.string.isRequired
}

export default FormImageField